import React from 'react';

import { Badge } from 'react-bootstrap';

import { Colors } from 'constants/colors';
import { ExitPopupLightIcon } from 'assets/icons';

interface IBadgeProps {
  label: any;
  color?: string;
  bg?: string;
  icon?: string;
  onDelete?: any;
  className?: string;
  pill?: boolean;
  variant?: string;
  dataTestId?: string;
}

const ClosableBadge = ({
  label,
  color,
  icon,
  onDelete,
  className,
  dataTestId,
  bg,
  ...props
}: IBadgeProps) => {
  return (
    <Badge
      bg={bg || 'undefined'}
      className={`tag d-inline-flex align-items-center p-2 ${className}`}
      style={{
        backgroundColor: color,
        color: props.variant === 'info' ? Colors.GRAY : Colors.WHITE
      }}
      data-test={dataTestId}
      {...props}
    >
      <img className="pe-1" src={icon} />
      <span className="p-1">{label}</span>
      {onDelete && (
        <ExitPopupLightIcon
          className="icon"
          onClick={onDelete}
          data-test={`${dataTestId}-delete`}
        />
      )}
    </Badge>
  );
};

export default ClosableBadge;
